/* Los topes de tamaño de Mi espacio, en un solo lugar.
 *
 * PLANILLA: lo que la base guarda por planilla (la CHECK
 * `espacio_planillas_datos_chicos`, y la misma en las versiones). Era 1 MB y
 * los Excel reales no entraban (Movimientos Diarios pesa 5,2 MB y Transcan
 * 2,8 MB, aunque el 80 % es formato de celdas vacías que al importar se tira).
 * Igna, 06/10: se sube a 5 MB.
 *
 * IMPORTAR: el archivo que se acepta para importar, por el hub, por mail o por
 * WhatsApp: 10 MB (el `file_size_limit` del bucket `importaciones`). Es más
 * que el de la planilla porque el archivo trae peso que no se guarda.
 *
 * Si cambian, cambian también la migración que pone la CHECK y el bucket, y
 * `MAX_BYTES` de `fibosheets_importar.py` en FlotaBot. */

export const TOPE_PLANILLA_MB = 5;
export const TOPE_PLANILLA_BYTES = TOPE_PLANILLA_MB * 1024 * 1024;

export const TOPE_IMPORTAR_MB = 10;
export const TOPE_IMPORTAR_BYTES = TOPE_IMPORTAR_MB * 1024 * 1024;
